export enum ViewMode { Symbolic, Absolute }